// Utility function to extract enum values and defaults from both JSON schema formats
export const extractEnumInfo = (property: any) => {
  // New format: anyOf with enum and default
  if (property.anyOf && Array.isArray(property.anyOf)) {
    const enumOption = property.anyOf.find((option: any) => option.enum);
    if (enumOption) {
      return {
        enum: enumOption.enum,
        defaultValue: property.default, // Default is at property level, not in anyOf
        type: enumOption.type || property.type,
      };
    }
  }

  // Handle union types like ["string", "null"]
  if (Array.isArray(property.type)) {
    const stringType = property.type.find((t: string) => t === 'string');
    if (stringType && property.enum) {
      return {
        enum: property.enum,
        defaultValue: property.default,
        type: 'string',
      };
    }
  }

  // Old format: direct enum property
  if (property.enum) {
    return {
      enum: property.enum,
      defaultValue: property.default,
      type: property.type,
    };
  }

  return {
    enum: null,
    defaultValue: property.default,
    type: property.type,
  };
};

export function getDefaultValues(schema: any) {
  return schema?.properties
    ? Object.entries(schema.properties).reduce(
        (acc, [key, property]: [string, any]) => {
          acc[key] = getDefaultValue(property);
          return acc;
        },
        {} as Record<string, any>
      )
    : {};
}

// Get default value for a property, considering enum defaults
function getDefaultValue(property: any) {
  const enumInfo = extractEnumInfo(property);

  // If there's a default value, use it
  if (enumInfo.defaultValue !== undefined) {
    return enumInfo.defaultValue;
  }

  // Otherwise use type-based defaults
  switch (property.type) {
    case 'string':
      return '';
    case 'number':
      return 0;
    case 'boolean':
      return false;
    case 'array':
      return [];
    default:
      return '';
  }
}
